import { render, staticRenderFns } from "./ledgerLog.vue?vue&type=template&id=0523b414&scoped=true"
import script from "./ledgerLog.vue?vue&type=script&lang=js"
export * from "./ledgerLog.vue?vue&type=script&lang=js"
import style0 from "./ledgerLog.vue?vue&type=style&index=0&id=0523b414&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0523b414",
  null
  
)

export default component.exports